import styled from 'styled-components/macro'

export default styled.h2`
  margin-top: ${props => props.theme.spacing.small};
  font-size: ${props => props.theme.small};
  font-weight: ${props => props.theme.lighter};
  color: ${props => props.theme.gray};
`
